import React, { Component } from 'react'
import SearchCard from './SearchCard';
import { SearchOutlined } from '@material-ui/icons'
export default class Search extends Component {
    render() {
     
        const { searchResult, title } =this.props.search;
        const {dispatch} =this.props;
    
         return (
            <div className="search">
                <p className="search-title"> <SearchOutlined fontSize='large' className="search-icon" /> Search Result for : {title}</p>
                <hr></hr>
                
               {searchResult!=undefined&&searchResult.map((search,key)=>{
                  return <SearchCard
                   data={search} key={key} dispatch={dispatch}
                   />
               })}
   </div>
        )
    }
}
